module.exports = __webpack_public_path__ + "static/media/060-doctor-1.62056fb2.svg";